import type { CrremSettings } from "features/energy-analysis-dashboard/model/types";

import { useCallback, useEffect, useState } from "react";

import type { CrremPathwayStoredConfig } from "../model/types";

import {
  patchCrremPathwayConfig,
  readCrremPathwayConfig,
  subscribeCrremPathwayConfig,
  toPathwayCrremSettings,
} from "../lib/crremPathwaySettingsStorage";

export const useCrremPathwaySettings = (projectId: string) => {
  const [config, setConfig] = useState(() => readCrremPathwayConfig(projectId));

  useEffect(() => {
    setConfig(readCrremPathwayConfig(projectId));
    return subscribeCrremPathwayConfig(projectId, setConfig);
  }, [projectId]);

  const updateConfig = useCallback(
    (change: Partial<CrremPathwayStoredConfig>) => {
      setConfig(patchCrremPathwayConfig(projectId, change));
    },
    [projectId]
  );

  const saveSettings = useCallback(
    (next: CrremSettings) => {
      updateConfig({ displayMetric: next.displayMetric, trendMethod: next.trendMethod });
    },
    [updateConfig]
  );

  return {
    config,
    saveSettings,
    settings: toPathwayCrremSettings(config),
    updateConfig,
  };
};
